<template>
  <div class="home">
    <div v-if="loadingCodeInfo">Laddar lite information...</div>
    <div v-else>
      <div v-if="!codeSuccess">
        <h3>Ojsan!</h3>
        <p>Din kod är ogiltlig vilket ställer till det lite. Prova igen. Annars kontakta support@nexa.se.</p>
      </div>
      <div v-else>
        Ditt nummer är nu bekräftat och tillagt till platsen. Du kommer händanefter att få SMS vid varningar.
      </div>
    </div>
  </div>
</template>

<style>
.home {
  margin:12px;
}
</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {},
  created () {

  },
  mounted () {
    fetch(`https://api.systemnexa2.se/1/account/locations/contacts/confirm?code=${this.$route.params.code}`)
    .then(res => res.json())
    .then(json => {
      this.codeSuccess = json.success
      this.loadingCodeInfo = false
    })
  },
  data: () => ({
    loadingCodeInfo: true,
    codeSuccess: false,
  }),
  methods: {}
}
</script>
